import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { bonuses, bonusesTotalValue } from '../data/bonuses';
export function Bonuses() {
  return <section className="w-full bg-sand py-20 sm:py-28" aria-labelledby="bonuses-title" data-id="element-16" data-mp="aujzm9neq52y">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-17" data-mp="fsv9gkdpcfl6">
        <SectionHeading eyebrow="Solo por hoy" title={<>
              6 bonos que <em className="not-italic text-clay" data-id="element-19" data-mp="5wi5mtog0lcp">no vas a pagar</em>
            </>} intro="Cada bono se vende por separado. Hoy, al descargar tu eBook, se van contigo sin costo adicional." data-id="element-18" data-mp="1un3jmyou3xv" />

        <img src="https://cdn.shopify.com/s/files/1/0825/1706/5986/files/fotocudrada.jpg?v=1781898603" alt="Kit digital Me Elijo: planificador, diario, guías y afirmaciones" className="mx-auto mt-12 w-full max-w-3xl rounded-[2rem] object-cover shadow-soft" loading="lazy" data-id="element-20" data-mp="3t1rayiyqvs6t" />

        <ul className="mt-12 grid gap-5 md:grid-cols-2" data-id="element-21" data-mp="3icvejinyew53">
          {bonuses.map((bonus, index) => <motion.li key={bonus.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.25
        }} transition={{
          duration: 0.45,
          delay: index % 2 * 0.08
        }} className="flex h-full flex-col rounded-3xl bg-cream p-7" data-id="element-22" data-mp="3df3ajqa1bjkj" data-mpi={index}>
              <div className="flex items-center justify-between gap-4" data-id="element-23" data-mp="2uh96lqnrjy90">
                <span className="inline-flex items-center gap-2 text-xs font-medium uppercase tracking-[0.2em] text-clay" data-id="element-24" data-mp="38g8qkl0bzoyu">
                  <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-25" data-mp="33gw6u94ray0h" />
                  {bonus.number}
                </span>
                <span className="rounded-full bg-plum px-3 py-1 text-xs font-medium uppercase tracking-[0.14em] text-cream" data-id="element-26" data-mp="noqbbaflyf6l">
                  Gratis hoy
                </span>
              </div>

              <h3 className="mt-4 font-display text-2xl leading-tight text-plum sm:text-3xl" data-id="element-27" data-mp="3ci4v7dri9jsc">
                {bonus.title}
              </h3>
              <p className="mt-1 text-sm italic text-ink/55" data-id="element-28" data-mp="3ljl6rou23ry5">{bonus.subtitle}</p>
              <p className="mt-4 flex-1 text-base leading-relaxed text-ink/75" data-id="element-29" data-mp="3lhi5u9rd8een">
                {bonus.description}
              </p>
              <p className="mt-4 border-l-2 border-blush pl-4 text-sm leading-relaxed text-plum" data-id="element-30" data-mp="2tsoq0d4vl35l">
                {bonus.promise}
              </p>
              <p className="mt-5 border-t border-plum/10 pt-4 text-sm text-ink/60" data-id="element-31" data-mp="2xujq5eb2lahs">
                Valor real:{' '}
                <span className="text-ink/45 line-through" data-id="element-32" data-mp="32r0h0g9nm2yk">{bonus.value}</span>{' '}
                <span className="font-medium text-clay" data-id="element-33" data-mp="37l4or1qquf0p">Hoy $0</span>
              </p>
            </motion.li>)}
        </ul>

        <p className="mt-12 text-center font-display text-2xl leading-snug text-plum sm:text-3xl" data-id="element-34" data-mp="2f3ivh2gzg141">
          Valor total de los bonos: <span className="line-through opacity-50" data-id="element-35" data-mp="27k9m398h82ez">{bonusesTotalValue}</span>
          <br data-id="element-36" data-mp="22l6gnnol3u6h" />
          Hoy, al descargar tu eBook, todos son <em className="not-italic text-clay" data-id="element-37" data-mp="22lg71cdjk3cp">gratis</em>.
        </p>
      </div>
    </section>;
}